(() => {
  if (window.CaffreyDrySpellMechanism) return;
  const controllers = new Map();
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const duration = 9900;
  const clamp = n => Math.max(0, Math.min(1, n));
  const surface = x => 529 + (x - 600) * .42 - Math.pow(Math.max(x - 800, 0), 2) * .00021;
  const drops = [{ x: 550, scale: 1.04, delay: 0 }, { x: 780, scale: .92, delay: 2150 }, { x: 640, scale: 1, delay: 4300 }];
  function create(root) {
    const state = { time: 0, frame: 0, last: 0, visible: false, playing: true, started: false, still: true };
    const waters = [...root.querySelectorAll('[data-ds-water]')];
    const pause = root.querySelector('[data-ds-pause]');
    const controls = root.querySelector('[data-ds-motion-controls]');
    function position(node, x, y, scale, sx, sy, shadow, phase, opacity = 1) {
      node.dataset.dsWaterState = phase;
      node.setAttribute('opacity', phase === 'waiting' ? '0' : String(opacity));
      node.querySelector('[data-ds-drop]').setAttribute('transform', 'translate(' + x.toFixed(2) + ' ' + y.toFixed(2) + ') scale(' + (scale * sx).toFixed(3) + ' ' + (scale * sy).toFixed(3) + ')');
      const shade = node.querySelector('[data-ds-shadow]');
      shade.setAttribute('cx', x.toFixed(2));
      shade.setAttribute('cy', (surface(x) + 4).toFixed(2));
      shade.setAttribute('rx', String(65 * scale));
      shade.setAttribute('opacity', String(shadow));
    }
    function paint() {
      const still = state.still || reduce.matches;
      root.dataset.dsPlaying = String(!still && state.playing && state.visible && !document.hidden);
      waters.forEach((node, i) => {
        const config = drops[i];
        if (still) {
          const x = [540, 850, 1160][i];
          position(node, x, surface(x) - 72 * config.scale, config.scale, 1, 1, .27, 'resting');
          return;
        }
        const t = state.time - config.delay;
        let x = config.x, y = 225, sx = .84, sy = 1.2, shadow = 0, phase = 'waiting';
        if (t >= 0 && t < 1750) {
          const p = clamp(t / 1750);
          y = 225 + (surface(x) - 72 * config.scale - 225) * Math.pow(p, 1.55);
          sx = .84 + .16 * p; sy = 1.2 - .2 * p;
          shadow = Math.pow(p, 6) * .27;
          phase = 'falling';
        } else if (t < 2250 && t >= 1750) {
          const bounce = Math.sin(clamp((t - 1750) / 500) * Math.PI);
          sx = 1 + .13 * bounce; sy = 1 - .15 * bounce;
          y = surface(x) - 72 * config.scale * sy;
          shadow = .27; phase = 'beading';
        } else if (t >= 2250 && t < 5550) {
          const p = clamp((t - 2250) / 3300);
          x += (1780 - x) * Math.pow(p, 1.55);
          sx = 1 + .04 * Math.sin(p * Math.PI * 5); sy = 1 - .03 * Math.sin(p * Math.PI * 5);
          y = surface(x) - 72 * config.scale * sy;
          shadow = .27; phase = 'rolling';
        }
        position(node, x, y, config.scale, sx, sy, shadow, phase, clamp(t / 260));
      });
      controls.hidden = reduce.matches;
      pause.textContent = state.playing ? pause.dataset.pauseLabel : pause.dataset.resumeLabel;
    }
    function stopFrame() { cancelAnimationFrame(state.frame); state.frame = 0; state.last = 0; }
    function tick(now) {
      state.frame = 0;
      if (!state.playing || !state.visible || document.hidden || reduce.matches || !root.isConnected) { state.last = 0; paint(); return; }
      if (state.last) state.time = (state.time + Math.min(now - state.last, 80)) % duration;
      state.last = now;
      paint();
      state.frame = requestAnimationFrame(tick);
    }
    function run() {
      stopFrame();
      if (state.playing && state.visible && !document.hidden && !reduce.matches) state.frame = requestAnimationFrame(tick);
      paint();
    }
    function motionChange() {
      state.still = reduce.matches || !state.started;
      if (!reduce.matches && state.visible) { state.started = true; state.still = false; state.time = 0; }
      run();
    }
    function click(event) {
      if (event.target.closest('[data-ds-replay]')) { state.started = true; state.still = false; state.time = 0; state.playing = true; run(); }
      if (event.target.closest('[data-ds-pause]')) { state.playing = !state.playing; run(); }
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      state.visible = entry.isIntersecting && entry.intersectionRatio >= .55;
      if (state.visible && !state.started && !reduce.matches) { state.started = true; state.still = false; state.time = 0; }
      run();
    }), { threshold: [0, .55] });
    observer.observe(root.querySelector('.cf-ds-surface-viewport'));
    root.addEventListener('click', click);
    reduce.addEventListener('change', motionChange);
    motionChange();
    return { state, run, destroy() { stopFrame(); observer.disconnect(); root.removeEventListener('click', click); reduce.removeEventListener('change', motionChange); } };
  }
  function initialise() {
    for (const [root, controller] of controllers) if (!root.isConnected) { controller.destroy(); controllers.delete(root); }
    document.querySelectorAll('[data-ds-mechanism]').forEach(root => { if (!controllers.has(root)) controllers.set(root, create(root)); });
  }
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', event => { for (const [root, controller] of controllers) if (event.target.contains(root)) { controller.destroy(); controllers.delete(root); } });
  document.addEventListener('shopify:section:reorder', initialise);
  document.addEventListener('visibilitychange', () => controllers.forEach(controller => controller.run()));
  window.CaffreyDrySpellMechanism = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
